<template lang="pug">
  b-container
    b-form-row.align-items-center.mt-3.mb-4
      b-col
        h4.mb-1 Entendimiento
    //platforms-tabs.mb-3(:active="platform", @click:active="platform = $event")
    date-range-picker.mb-3(v-bind="calendar_props", v-model="dates", :maxDate="$moment().format()", @update="changeDates")
      template.w-100(v-slot:input="picker")
        b-input-group
          b-form-input.readonly-white(placeholder="Seleccionar fecha...", :value="parse_dates", readonly)
          b-input-group-append
            b-input-group-text
              calendar-icon.text-secondary.icon-sm
    div(v-for="insight in insights", :key="insight.id")
      b-link.text-reset(v-b-toggle="insight.id")
        h5 {{insight.title}}
          chevron-down-icon.ml-1.icon-md
      b-collapse.mb-4(:id="insight.id", visible)
        div(v-if="insight.id === 'congrats'")
          div(v-for="chart in insight.charts", :key="chart.id")
            p.text-secondary.text-center {{ chart.title }}
            b-form-row.align-items-flex-end
              b-col.text-center(v-for="data in chart.data", :key="data.topic")
                v-icon.icon(v-bind="data.icon")
                .text-primary.font-weight-bold {{data.topic}}
                .text-help {{data.total}} ({{data.percent}}%)
            //b-row.align-items-start
              b-col(md="5")
                .d-flex.justify-content-between(v-for="data in chart.data", :key="data.topic")
                  p.mb-0 {{data.topic}}
                  p.mb-0 {{data.total}} ({{data.percent}}%)
              b-col(md="7")
                .w-100.h-100(:id="chart.id + '_container'", style="min-height: 320px", v-show="chart.data.length")
                  canvas(:id="chart.id")
            empty-message(v-if="!chart.data.length", message="Aún no hay datos para mostrar")
        b-row.justify-content-center(no-gutters, v-else)
          b-col.mb-2(:md="10", v-for="chart in insight.charts", :key="chart.id")
            .text-center
              b-spinner(variant="info", v-if="loading")
              p.mb-0.text-secondary(v-else) {{ chart.title }}
            empty-message(v-if="!chart.data.length", message="Aún no hay datos para mostrar")
            canvas(:id="chart.id", v-show="chart.data.length")
        small.text-help(v-if="insight.details") {{insight.details}}
    div(v-if="feedbacks.length")
      b-link.text-reset(v-b-toggle="'feedbacks_section'")
        h5 Opiniones de los usuarios
          chevron-down-icon.ml-1.icon-md
      b-collapse.mb-4#feedbacks_section(visible)
        .ml-3.mb-4(v-for="feedback in feedbacks", :key="feedback.type")
          div(v-if="feedback.type === 'csat'")
            b-link.text-reset(v-b-toggle="'csat_section'")
              h5 Nivel de satisfacción del cliente
                chevron-down-icon.ml-1.icon-md
            b-collapse.mb-4#csat_section(visible)
              .d-flex.justify-content-between.align-items-center
                .text-warning
                  v-icon.icon.mr-1(v-for="(star, i) in feedback.stars" :name="star", :key="i", scale="1.5")
                  star-icon.icon.mr-1(v-for="star in  Math.floor(5 - feedback.csat)", :key="'star' + star", scale="1.5")
                  span.text-dark {{feedback.csat}} de 5
                b-button(variant="info", @click="getComments(feedback.type)") Ver Comentarios
              b-row.my-2
                b-col(md="6")
                  b-row.mb-2(no-guters, v-for="(score, index) in feedback.scores", :key="index")
                    b-col(lg="6")
                      span.mr-2 {{score.title}}
                      span.text-secondary {{score.percent.toFixed(2)}}%
                    b-col(lg="6")
                      b-progress(:value="score.percent" variant="warning", :key="score.title")
                b-col(md="6")
                  canvas#csat-chart
          div(v-if="feedback.type === 'ces'")
            b-link.text-reset(v-b-toggle="'ces_section'")
              h5 ¿Qué tan fácil fue usar la herramienta para tus usuarios?
                chevron-down-icon.ml-1.icon-md
            b-collapse.mb-4#ces_section(visible)
              .d-flex.justify-content-between.align-items-center.mb-2
                h5.text-secondary.mb-0 Indicador de esfuerzo del cliente {{feedback.ces}}%
                b-button(variant="info", @click="getComments(feedback.type)") Ver Comentarios
              b-row.justify-content-center
                b-col(md="8")
                  canvas#ces-chart
          div(v-if="feedback.type === 'nps'")
            b-link.text-reset(v-b-toggle="'nps_section'")
              h5 Grado de fidelidad y recomendación de tus usuarios
                chevron-down-icon.ml-1.icon-md
            b-collapse.mb-4#nps_section(visible)
              .d-flex.justify-content-between.align-items-center.mb-2
                h5.text-secondary.mb-0 Nivel de satisfacción {{feedback.nps}}
                b-button(variant="info", @click="getComments(feedback.type)") Ver Comentarios
              b-row.justify-content-center
                b-col(md="8")
                  canvas#nps-chart
    b-modal(v-model="comment_modal", title-class="w-100", scrollable, size="lg", footer-class="justify-content-start", @hidden="selected_type = score = null")
      template(v-slot:modal-title)
        .d-flex.justify-content-between
          h5.mb-0 Comentarios de usuarios
          b-dropdown(variant="primary", size="sm", right, text="Filtrar comentarios")
            b-dropdown-item(@click="score = null") Todos
            b-dropdown-item(v-for="(type, index) in filter_types[selected_type]", :key="type", @click="score = selected_type === 'nps' ? type : index+1") {{type}}
      empty-message.py-5(:message="score ? 'No hay comentarios que mostrar' : 'Aún no hay comentarios de esta encuesta'", v-if="!comments.length")
      b-card.shadow(v-for="comment in comments", :key="comment.comment_id")
        .text-secondary {{comment.question}}
        .my-2 {{comment.additional_comment}}
        .d-flex.justify-content-between
          .text-warning(v-if="selected_type === 'csat'")
            v-icon.icon.mr-1(v-for="star in parseInt(comment.score)" name="star", :key="star")
            star-icon.icon-sm.mr-1(v-for="star in (5 - comment.score)", :key="star")
          .small.text-secondary(v-else-if="selected_type === 'ces'") {{filter_types.ces[comment.score-1]}}
          .small.text-secondary.text-right {{$moment(comment.createdAt).format('LL')}}
      template(v-slot:modal-footer)
        .d-flex.align-items-center
          b-pagination.mb-0(:total-rows="v_paginationItemsCount", :per-page="v_paginationLimit", :value="paginationCurrentPage", @change="paginationPageChanged($event, 'loadMoreComments')", v-if="v_paginationShow")
          b-spinner.ml-3(small, variant="primary", v-if="loading")
    b-modal(v-model="intent_modal", :title="selected_intent.intent" size="lg", scrollable, centered, hide-footer, @hidden="selected_intent = {}")
      empty-message(v-if="selected_intent.topics && !selected_intent.topics.length", message="Aún no hay datos para mostrar")
      div(v-show="selected_intent.topics && selected_intent.topics.length")
        //span.ml-1 {{selected_intent.total}} mensajes
        //span.ml-1 - {{selected_intent.percent}}% total
        b-row.align-items-center.text-secondary
          b-col(cols="4") Topic
          b-col(cols="4") Mensajes
          b-col(cols="4") Porcentaje
        b-row.align-items-center(v-for="topic in selected_intent.topics", :key="topic.topic")
          b-col(cols="4") {{topic.topic}}
          b-col(cols="4") {{topic.total}}
          b-col(cols="4") {{topic.percent}}%
        canvas(id="selected_intent_chart")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
const insightsController = createNamespacedHelpers('insights')
import PlatformsTabs from '@/components/PlatformsTabs.vue'
import Chart from 'chart.js';
import 'chartjs-plugin-datalabels'
import Days from '@/data/days'
import Months from '@/data/months'
import KolorWheel from "kolorwheel";

export default {
  data () {
    return {
      loading: false,
      intent_modal: false,
      comment_modal: false,
      platform: "all",
      calendar_props: {
        linkedCalendars: false,
        showDropdowns: true,
        ranges: false,
        opens: 'right',
        localeData: {
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar',
          daysOfWeek: Days.daysShort,
          monthNames: Months.monthsShort,
          firstDay: 0
        },
        parentEl: '#router-container'
      },
      dates: {
        startDate: null,
        endDate: null,
      },
      selected_type: null,
      score: null,
      selected_intent: {},
      insights: [],
      feedbacks: [],
      comments: [],
      graphs: [],
      filter_types: {
        csat: ["1 Estrella", "2 Estrellas", "3 Estrellas", "4 Estrellas", "5 Estrellas"],
        ces: [
          "Muy en desacuerdo",
          "Desacuerdo",
          "Un poco en desacuerdo",
          "Indeciso",
          "Un poco  de acuerdo",
          "De acuerdo",
          "Totalmente de acuerdo",
        ],
        nps: ['Promotores', 'Detractores']
      }
    }
  },
  computed: {
    parse_dates () {
      return this.$moment(this.dates.startDate).format('DD MMM YYYY') + ' - ' + this.$moment(this.dates.endDate).format('DD MMM YYYY')
    },
  },
  methods: {
    ...mapActions(["insights/all", "feedback/metrics", "feedback/all"]),
    getInsights () {
      let self = this
      this.showLoadingScreen()

      this['insights/all']({
        account_id: self.$route.params.account_id,
        params: {
          init_date: this.dates.startDate,
          final_date: this.dates.endDate
        },
        callback: res => {
          self.hideLoadingScreen()
          if (res.error) {
            self.$message.error(res.error)
          } else {
            /*self.insights.push({
              title: "Topics más frecuentes del Bot",
              id: "common",
              charts: [
                {id: "comunes", title: "Topics más frecuentes del bot", ...res.resource.comunes}
              ]
            })*/

            const {respondidos = [], no_respondidos = [], faqs = [], quejas = [], agradecimientos = [], total = 0} = res.resource

            self.insights.push({
              title: "Conoce más sobre los mensajes a los que responde y no responde tu bot",
              id: "answered",
              charts: [
                { id: "respondidos", title: "Topics de los mensajes respondidos por el bot", data: respondidos },
                { id: "faqs", title: "Total de mensajes respondidos con FAQ's", data: faqs },
                { id: "no_respondidos", title: "Topics con menor nivel de respuesta", data: no_respondidos }
              ],
              details: "Da click en la gráfica para ver más información"
            })

            let congrats = []
            agradecimientos.slice(0, 5).sort((a,b) => b.total - a.total).forEach(( el, i, array ) => {
              if(i === 0) {
                el.icon = {name: 'trophy', scale:"8", class:'text-warning'}
              } else if(i < array.length / 2) {
                el.icon = {name: 'award', scale:"5", class:'text-purple'}
              } else {
                el.icon = {name: 'medal', scale:"3", class:'text-primary'}
              }
              i % 2 === 0 ? congrats.push(el) : congrats.unshift(el);
            });

            self.insights.push({
              title: "¡Mira las felicitaciones que te han dado!",
              id: "congrats",
              charts: [
                {id:"agradecimientos", title: "Felicitaciones de tus Usuarios", data: congrats}
              ]
            })

            self.insights.push({
              title: "Conoce las quejas tus usuarios",
              id: "complaints",
              charts: [
                {id:"quejas", title: `Topics más frecuentes de quejas (Total de mensajes: ${total})`, data: quejas}
              ]
            })

            this.$nextTick(() => {
              this.createIntentsChart({respondidos, no_respondidos})
              this.createComplainsChart({faqs, quejas})
              //this.createBubbles(agradecimientos)
            })
          }
        }
      });
    },
    getFeedbackMetrics() {
      let self = this
      //this.showLoadingScreen()

      this['feedback/metrics']({
        account_id: self.$route.params.account_id,
        params: {
          init_date: self.dates.startDate,
          final_date: self.dates.endDate
        },
        callback: res => {
          //self.hideLoadingScreen()
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.feedbacks = res.resource.slice()

            let csat = self.feedbacks.find(el => el.type === "csat")
            if(csat) {
              csat.csat = csat.csat ? csat.csat.toFixed(2) : "-"
              csat.scores = csat.scores.reverse();
              csat.stars = this.stars(csat.csat);
            }

            self.$nextTick(() => {
              let nps = self.feedbacks.find(el => el.type === "nps")
              if(nps) {
                nps.nps = nps.nps ? nps.nps.toFixed(2) : "-"
                self.createNpsChart(nps)
              }
              let ces = self.feedbacks.find(el => el.type === "ces")
              if(ces) {
                ces.ces = ces.ces ? ces.ces.toFixed(2) : "-"
                self.createCesChart(ces.scores)
              }
            })
          }
        }
      });
    },
    getComments (type) {
      this.loading = true
      let self = this
      this.selected_type = type

      this['feedback/all']({
        account_id: self.$route.params.account_id,
        params: {
          ...self.paginationParamsObject,
          answered: true,
          type: type,
          score: this.score
        },
        callback: res => {
          this.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.parsePaginationDataFromResponse(res)
            this.comments = res.resource.filter(el => !!el.additional_comment)
            this.comment_modal = true
          }
        }
      });
    },
    loadMoreComments () {
      this.getComments(this.selected_type)
    },
    createIntentsChart (insights) {
      const self = this
      for (let key in insights) {
        let insight = insights[key].slice(0, 10)
        if(!insight.length) continue

        insight.forEach(el => {
          const others = el.topics.filter(el => el.percent <= 0.1)
          el.topics = el.topics.filter(el => el.percent > 0.1).slice(0, 10).sort((a,b) => b.total - a.total)

          if(others.length) {
            const othersTotal = others.reduce((total, el) => total + el.total, 0)
            el.topics.push({"topic": "Otros","total": othersTotal, "percent": 0.1})
          }
        })

        let chart = this.createChart({
          ctx: document.getElementById(key).getContext('2d'),
          type: 'horizontalBar',
          labels: insight.map(el => el.intent),
          datasets: [{
            data: insight.map(el => el.total),
            backgroundColor: insight.map((el,i) => {
              let color = new KolorWheel([80*(i+1), 80, 75])
              return color.getHex()
            }),
            borderWidth: 1
          }],
          options: {
            responsive: true,
            maintainAspectRatio: true,
            legend: { display: false },
            cornerRadius: 5,
            scales: {
              xAxes: [{
                ticks: {
                  autoSkip: false,
                  beginAtZero: true,
                  fontSize: 15,
                }
              }],
              yAxes: [{
                stacked: true,
                ticks: {
                  autoSkip: false,
                  beginAtZero: true,
                  fontSize: 15,
                }
              }]
            },
            plugins: {
              datalabels: {
                anchor: 'end',
                align: 'start',
                offset: 3,
                color: '#404040',
                clamp: true,
                overlap: 'auto',
                font: {size: 15},
              }
            },
            tooltips: {
              callbacks: {
                label: function (tooltipItem) {
                  let label = insight[tooltipItem.index]
                  return `${label.total} (${label.percent}%)`;
                }
              }
            },
            onClick: (e, items) => {
              if(items.length) {
                self.selected_intent = insight[items[0]._index]
                if(self.selected_intent && self.selected_intent.topics) {
                  self.intent_modal = true
                  self.$nextTick(() => {
                    self.createTopicsChart({selected_intent_chart: self.selected_intent.topics || []})
                  })
                }
              }
            }
          }
        });
        this.graphs.push(chart)
      }
    },
    createTopicsChart (insights) {
      for (let key in insights) {
        let insight = insights[key]
        if(!insight.length) continue

        let chart = this.createChart({
          ctx: document.getElementById(key).getContext('2d'),
          type: 'pie',
          labels: insight.map(el => `${el.topic} (${el.percent}%)`),
          datasets: [{
            data: insight.map(el => el.total),
            backgroundColor: insight.map((el,i) => {
              let color = new KolorWheel([65*i, 80, 75])
              return color.getHex()
            }),
            borderWidth: 1
          }],
          options: {
            responsive: true,
            maintainAspectRatio: true,
            plugins: {
              datalabels: {
                color: '#404040',
                font: {size: 20}
              }
            }
          }
        });
        this.graphs.push(chart)
      }
    },
    createComplainsChart (complains) {
      for (let key in complains) {
        let insight = complains[key]
        if(!insight.length) continue

        const others = insight.filter(el => el.percent <= 0.1)
        insight = insight.filter(el => el.percent > 0.1).slice(0, 10).sort((a,b) => b.total - a.total)

        if(others.length) {
          const othersTotal = others.reduce((total, el) => total + el.total, 0)
          insight.push({"topic": "Otros","total": othersTotal, "percent": 0.1})
        }

        let chart = this.createChart({
          ctx: document.getElementById(key).getContext('2d'),
          type: 'horizontalBar',
          labels: insight.map(el => `${el.topic} (${el.percent}%)`),
          datasets: [{
            data: insight.map(el => el.total),
            backgroundColor: insight.map((el,i) => {
              let color = new KolorWheel([65*i, 80, 75])
              return color.getHex()
            }),
            borderWidth: 1
          }],
          options: {
            responsive: true,
            maintainAspectRatio: true,
            legend: { display: false },
            cornerRadius: 5,
            scales: {
              xAxes: [{
                ticks: {
                  autoSkip: false,
                  beginAtZero: true,
                  fontSize: 15,
                }
              }],
              yAxes: [{
                stacked: true,
                ticks: {
                  autoSkip: false,
                  beginAtZero: true,
                  fontSize: 15,
                }
              }]
            },
            plugins: {
              datalabels: {
                anchor: 'end',
                align: 'start',
                offset: 3,
                color: '#404040',
                clamp: true,
                overlap: 'auto',
                font: {size: 15},
              }
            },
          }
        });
        this.graphs.push(chart)
      }
    },
    createCesChart (scores) {
      let chart = this.createChart({
        ctx: document.getElementById('ces-chart').getContext('2d'),
        type: 'horizontalBar',
        labels: scores.map(el => `${el.title} (${el.total}%)`),
        datasets: [{
          data: scores.map(el => el.total),
          backgroundColor: scores.map((el, i) => {
            let color = new KolorWheel([20 * i, 80, 75])
            return color.getHex()
          }),
          borderWidth: 1
        }],
        options: {
          cornerRadius: 5,
          responsive: true,
          maintainAspectRatio: true,
          legend: { display: false },
          scales: {
            xAxes: [{
              stacked: true,
              ticks: {
                autoSkip: false,
                beginAtZero: true,
                fontSize: 12,
                minor:{
                  stepSize: 1,
                  autoSkip: false
                }
              }
            }],
            yAxes: [{
              stacked: true,
              ticks: {
                autoSkip: false,
                beginAtZero: true,
                fontSize: 10,
                minor:{
                  stepSize: 1,
                  autoSkip: false
                }
              }
            }]
          },
          plugins: {
            datalabels: {
              color: '#404040',
              font: {size: 15}
            }
          }
        }
      });
      this.graphs.push(chart)
    },
    createNpsChart ({ promoters, detractors }) {
      let chart = this.createChart({
        ctx: document.getElementById('nps-chart').getContext('2d'),
        type: 'doughnut',
        labels: ["Promotores", "Detractores"],
        datasets: [{
          data: [promoters, detractors],
          backgroundColor: ["#78fd78", "#fd7474"],
          borderWidth: 1
        }],
        options: {
          responsive: true,
          maintainAspectRatio: true,
          plugins: {
            datalabels: {
              color: '#404040',
              font: {size: 25}
            }
          }
        }
      });
      this.graphs.push(chart)
    },
    createChart ({ctx, type, labels, datasets, options}) {
      return new Chart(ctx, {
        type: type,
        data: {
          labels: labels,
          datasets: datasets
        },
        options: options
      });
    },
    createBubbles (congrats) {
      let {offsetWidth, offsetHeight} = document.getElementById("agradecimientos_container")
      let ctx = document.getElementById("agradecimientos").getContext('2d')
      ctx.canvas.width = offsetWidth
      ctx.canvas.height = offsetHeight
      let limit = 5
      if(congrats.length < limit){
        limit = congrats.length
      }
      let w = offsetWidth/(limit + 1.6);
      let centerX = offsetWidth/2
      let centerY = offsetHeight/2

      for (let i = 0; i < limit; i++) {
        let color = new KolorWheel([45 * i, 100, 85])
        let aux = i > 0 ? !!(i % 2) ? 0.5 : 1.5 : 1
        let auy = i > 0 ? i > 2 ? 0.6 : 1.4 : 1
        let x = centerX * aux
        let y = centerY * auy
        w -= i * 3
        ctx.beginPath();
        ctx.fillStyle = color.getHex();
        ctx.arc(x, y, w, 0, 2 * Math.PI, false);
        ctx.fill();
        ctx.fillStyle = 'black';
        ctx.font = '15pt Calibri';
        ctx.textAlign = 'center';
        ctx.fillText(congrats[i].topic, x, y+3);
      }
    },
    stars (score) {
      let icons = []
      let complete = Math.floor(score)
      for (let i = 0; i < complete; i++) {
        icons.push('star')
      }
      if(score % 1 !== 0) {
        icons.push('star-half-alt')
      }
      return icons
    },
    changeDates () {
      this.insights = [];
      this.feedbacks = [];
      this.graphs.forEach(el => el.destroy());
      this.graphs = [];
      this.getInsights();
      this.getFeedbackMetrics();
    }
  },
  mounted () {
    this.dates.startDate = this.$moment().subtract(3, 'M').format();
    this.dates.endDate = this.$moment().format()
    this.getInsights()
    this.getFeedbackMetrics()
  },
  watch: {
    selected_type () {
      this.resetPaginationData()
    },
    score () {
      if(this.comment_modal && this.selected_type) {
        this.resetPaginationData()
        this.getComments(this.selected_type)
      }
    }
  },
  components: { PlatformsTabs }
}
</script>

<style lang="scss" scoped>
</style>
